import z from 'zod';
import { SkillSchema } from './skillSchema';
export const CreateUserSkillV2Schema = z
    .object({
    skill: SkillSchema.required(),
    type: z.enum(['other', 'digital']),
    level: z.enum(['professional', 'advanced', 'basic']),
    description: z.string().max(500).optional().describe('Skill Description')
})
    .describe('Create User Skill object with skill, level and description');
//# sourceMappingURL=createUserSkillV2Schema.js.map